"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var advices_1 = require("./src/advices");
var joint_points_1 = require("./src/joint_points");
var joint_points_2 = require("./src/joint_points");
var core_1 = require("./src/core");
exports.Wove = core_1.Wove;
exports.Metadata = core_1.Metadata;
exports.MethodMetadata = core_1.MethodMetadata;
exports._AspectRegistry = core_1.AspectRegistry;
exports._Targets = core_1.Targets;
var joint_points_3 = require("./src/joint_points");
exports.MemberPrecondition = joint_points_3.MemberPrecondition;
exports.beforeMethod = joint_points_1.makeMethodCallAdviceDecorator(advices_1.BeforeAdvice);
exports.afterMethod = joint_points_1.makeMethodCallAdviceDecorator(advices_1.AfterAdvice);
exports.aroundMethod = joint_points_1.makeMethodCallAdviceDecorator(advices_1.AroundAdvice);
exports.onThrowOfMethod = joint_points_1.makeMethodCallAdviceDecorator(advices_1.OnThrowAdvice);
exports.beforeSetter = joint_points_2.makeFieldSetAdviceDecorator(advices_1.BeforeAdvice);
exports.afterSetter = joint_points_2.makeFieldSetAdviceDecorator(advices_1.AfterAdvice);
exports.aroundSetter = joint_points_2.makeFieldSetAdviceDecorator(advices_1.AroundAdvice);
exports.onThrowOfSetter = joint_points_2.makeFieldSetAdviceDecorator(advices_1.OnThrowAdvice);
exports.beforeGetter = joint_points_2.makeFieldGetAdviceDecorator(advices_1.BeforeAdvice);
exports.afterGetter = joint_points_2.makeFieldGetAdviceDecorator(advices_1.AfterAdvice);
exports.aroundGetter = joint_points_2.makeFieldGetAdviceDecorator(advices_1.AroundAdvice);
exports.onThrowOfGetter = joint_points_2.makeFieldGetAdviceDecorator(advices_1.OnThrowAdvice);
exports.beforeStaticMethod = joint_points_1.makeStaticMethodAdviceDecorator(advices_1.BeforeAdvice);
exports.afterStaticMethod = joint_points_1.makeStaticMethodAdviceDecorator(advices_1.AfterAdvice);
exports.aroundStaticMethod = joint_points_1.makeStaticMethodAdviceDecorator(advices_1.AroundAdvice);
exports.onThrowOfStaticMethod = joint_points_1.makeStaticMethodAdviceDecorator(advices_1.OnThrowAdvice);
// Async
exports.asyncOnThrowOfMethod = joint_points_1.makeMethodCallAdviceDecorator(advices_1.AsyncOnThrowAdvice);
exports.asyncOnThrowOfSetter = joint_points_2.makeFieldSetAdviceDecorator(advices_1.AsyncOnThrowAdvice);
exports.asyncOnThrowOfGetter = joint_points_2.makeFieldGetAdviceDecorator(advices_1.AsyncOnThrowAdvice);
exports.asyncOnThrowOfStaticMethod = joint_points_1.makeStaticMethodAdviceDecorator(advices_1.AsyncOnThrowAdvice);
